import React, { useEffect, useState } from "react";
import { Box, Fade, IconButton, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddNewPartyModal from "../../pages/PrimeFigma/Modals/AddNewPartyModal";

const style = {
  position: "absolute",
  right: "10%",
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: "0px",
  overflow: "hidden",
  height: "85%",
  width: "80%",
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50% )",
};

function AddPartyModal({
  open,
  setOpen,
  setsuccessSnakbar,
  setSnakbarText,
  partyID,
  partyType,
  setNewPartyID,
  partyName,
  page,
  setNeedDashBoardRender,
  setSnakbarTex,
  partyGroupId,
  setNewLedgerResponse,
}) {
  const [customerorSupplier, setCustomerorSupplier] = useState(true);
  const [newCustomerRes, setNewCustomerRes] = useState(false);
  const [currentPage, setCurrentPage] = useState("");

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (page === "purchaseInvoice") {
      setCustomerorSupplier(false);
    } else {
      if (page === "salesInvoice") {
        setCustomerorSupplier(true);
      }
    }
  }, [open]);

  function isEmpty(str) {
    return !str || /^\s*$/.test(str);
  }

  return (
    <Modal
      sx={{ width: "200px 200px" }}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Box className="custom-scrollbar" sx={style}>
          <Box
            sx={{
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: 2,
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                {!isEmpty(partyID) ? (
                  <Typography
                    sx={{
                      color: "#fff",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {
                      //taxable ? 'Purchase And Expense - Taxable' : 'Purchase And Expense - Non Taxable'
                      partyType == "CUSTOMER"
                        ? "Customer (Debtors)"
                        : "Supplier (Creditors)"
                    }
                    {page !== "OPeningBalance" && page !== "AccountModal" && (
                      <IconButton aria-label="delete" onClick={handleClose}>
                        <CloseIcon sx={{ color: "#fff" }} />
                      </IconButton>
                    )}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      color: "#fff",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {customerorSupplier
                      ? "Customer (Debtors)"
                      : "Supplier (Creditors)"}
                    {page !== "OPeningBalance" &&
                      page !== "Receivables" &&
                      page !== "Payables" &&
                      page !== "AccountModal" && (
                        <IconButton aria-label="delete" onClick={handleClose}>
                          <CloseIcon sx={{ color: "#fff" }} />
                        </IconButton>
                      )}
                  </Typography>
                )}
              </Box>
            </Box>

            <Box sx={{ overflowY: "scroll", flex: 1 }}>
              {partyGroupId && (
                <Box>
                  <AddNewPartyModal
                    open={open}
                    setOpen={setOpen}
                    partyType={
                      partyType == "SUPPLIER"
                        ? "supplier"
                        : partyType == "CUSTOMER"
                        ? "customer"
                        : "Add Party"
                    }
                    setNewPartyID={setNewPartyID}
                    partyParamsID=""
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default AddPartyModal;
